import { Outlet } from 'react-router'

const LegalPage = () => {
  return (
    <article className="space-y-8 mx-auto max-w-3xl prose mb-16">
      <Outlet />
    </article>
  )
}

export default LegalPage
